import {type FC, useEffect} from 'react';

import type {Props} from './types';

import {Alert} from '../../components/Alert';
import {Backdrop} from '../../components/Backdrop';
import {AlertConfetti} from '../../components/Confetti';
import {alert} from './alertApi';
import {useController} from './controller';
import * as S from './styles';

export const AlertContainer: FC<Props> = ({
  animationDuration = 200,
  disableBodyScroll = true,
}) => {
  const {
    bottomOffset,
    clearQueue,
    confirm,
    currentAlert,
    getCurrentAlert,
    hide,
    isHiding,
    isShown,
    show,
    showError,
    success,
    update,
  } = useController({animationDuration, disableBodyScroll});

  useEffect(() => {
    // @ts-expect-error: Type 'T' is not assignable to type 'void'
    alert.show = show;
    alert.hide = hide;
    // @ts-expect-error: Type 'T' is not assignable to type 'void'
    alert.success = success;
    // @ts-expect-error: Type 'T' is not assignable to type 'void'
    alert.update = update;
    alert.clearQueue = clearQueue;
    // @ts-expect-error: Type 'T' is not assignable to type 'void'
    alert.getCurrentAlert = getCurrentAlert;
    // @ts-expect-error: Type 'T' is not assignable to type 'void'
    alert.confirm = confirm;
    // @ts-expect-error: Type 'T' is not assignable to type 'void'
    alert.error = showError;
    alert.isShown = isShown;
  }, [
    clearQueue,
    hide,
    show,
    success,
    update,
    getCurrentAlert,
    isShown,
    confirm,
    showError,
  ]);

  return currentAlert ? (
    <S.Container $bottomOffset={bottomOffset}>
      <Backdrop animationDuration={animationDuration} isHiding={isHiding} />
      {currentAlert.confetti ? <AlertConfetti /> : null}
      <Alert
        {...currentAlert}
        animationDuration={animationDuration}
        isHiding={isHiding}
      />
    </S.Container>
  ) : null;
};
